import { redirect } from 'react-router'
import { requireUserId } from '#app/utils/auth.server.ts'
import { sendEmail } from '#app/utils/email.server.ts'
import { prisma } from '#app/utils/db.server.ts'

export async function action({ request }: { request: Request }) {
	const userId = await requireUserId(request)

	// Get the user to include their name in the email
	const user = await prisma.user.findUnique({
		where: { id: userId },
		select: { name: true },
	})

	// Email details
	const to = 'cbaker@jpgacademy.org'
	const subject = 'PaideiaTrack Update: New Infractions System (March 2024)'
	const emailContent = `
Dear Chris,

I'm pleased to share the latest updates to the PaideiaTrack system that have been implemented in our March 2024 release:

Key Improvements:

1. Enhanced Disciplinary Infractions System
   - New intuitive form for creating and managing infractions
   - Built-in severity classification (minor, moderate, major)
   - Automatic demerit calculation based on severity level
   - Support for detailed incident descriptions and private notes

2. Admin Review Workflow
   - New approval/rejection process for infractions
   - Admin dashboard for reviewing pending infractions
   - Improved notification system for status changes

3. FACTS Integration Improvements
   - More reliable student and class data synchronization
   - Enhanced local caching for improved performance
   - Better handling of edge cases and error conditions

4. UI/UX Enhancements
   - Improved mobile-responsive design
   - Cleaner, more intuitive interface for teachers
   - Better visualization of student behavior patterns

All changes have been documented in the updated README file in the repository.

Next Steps:
- System testing with a small group of teachers
- Gathering feedback on the new workflow
- Planning for full rollout before end of school year

Please let me know if you'd like to schedule a demo of the new features.

Best regards,
${user?.name || 'The PaideiaTrack Team'}
`

	// Send the email using the application's email service
	const response = await sendEmail({
		to,
		subject,
		html: emailContent.replace(/\n/g, '<br />'),
		text: emailContent,
	})

	if (response.status === 'error') {
		// Handle error - in a real app you might want to show an error message
		console.error('Failed to send email:', response.error)
	} else {
		console.log('Email sent successfully:', response.data)
	}

	// Redirect back to the dashboard after sending the email
	return redirect('/dashboard?emailSent=true')
}

export default function SendEmail() {
	return null
}
